// Simple i18n strings for NL / EN / FR
export const LANGUAGES = [
  { code: "nl", label: "NL", flag: "https://flagcdn.com/w40/be.png" },
  { code: "en", label: "EN", flag: "https://flagcdn.com/w40/gb.png" },
  { code: "fr", label: "FR", flag: "https://flagcdn.com/w40/fr.png" },
];

export const TRANSLATIONS = {
  nl: {
    tagline: "Snel opwaarderen voor bestaande klanten",
    yourDetails: "Uw gegevens",
    yourDetailsHint: "Vul uw mobiel nummer en e-mailadres in. Daarna kunt u een bundel kiezen.",
    mobileLabel: "Jan Mobile nummer",
    mobilePlaceholder: "+32 4XX XX XX XX",
    confirmMobileLabel: "Bevestig nummer",
    confirmMobilePlaceholder: "Herhaal uw nummer",
    emailLabel: "E-mailadres",
    emailPlaceholder: "naam@voorbeeld.be",
    emailHint: "U ontvangt een bevestiging na betaling.",
    tabAllIn: "All-In",
    tabData: "DATA Only",
    tabCredit: "Credit",
    tabAll: "Alle producten",
    buy: "KOOP",
    processing: "Even geduld...",
    invalidMobile: "Voer een geldig mobiel nummer in",
    mobileMismatch: "De mobiele nummers komen niet overeen",
    invalidEmail: "Voer een geldig e-mailadres in",
    paymentCancelled: "Betaling geannuleerd. U kunt opnieuw proberen.",
    contactTitle: "Klantenservice",
    whatsapp: "WhatsApp",
    email: "E-mail",
    footer: "Snel opwaarderen voor bestaande klanten",
    paymentLoading: "Betaling verwerken...",
    paymentLoadingHint: "Een ogenblik geduld, wij bevestigen uw betaling.",
    paymentSuccess: "Betaling geslaagd",
    paymentSuccessHint: "Bedankt! Uw bundel wordt zo snel mogelijk geactiveerd.",
    bundle: "Bundel",
    mobileNr: "Mobiel nr.",
    amount: "Bedrag",
    status: "Status",
    paid: "Betaald",
    confirmationSentTo: "Een bevestiging is verzonden naar",
    sessionExpired: "Sessie verlopen",
    timeout: "Time-out",
    somethingWrong: "Er ging iets mis",
    backToShop: "Terug naar de winkel",
    incl: "incl. btw",
    popular: "POPULAIR",
    freeWord: "gratis",
    dataPromo: "\ud83c\udf81 Tijdelijk gratis MIN & SMS bij elke DATA Only-DEAL",
    bestDeal: "BESTE DEAL",
    tabPrepaid: "1 Maand Deal",
    tab3Month: "3 Maanden Deal",
    tab6Month: "6 Maanden Deal",
    perMonthShort: "/mnd",
    months3Promo: "\ud83d\udcb0 Eenmalig betalen, 3 maanden lang elke maand je deal automatisch bijgeschreven",
    months6Promo: "\ud83d\udcb0 Eenmalig betalen, 6 maanden lang elke maand je deal automatisch bijgeschreven",
    months3Prefix: "3 Maanden",
    months6Prefix: "6 Maanden",
    creditPromo: "\u267e\ufe0f Onbeperkte geldigheid",
    monthsFooterTitle: "Hoe werkt een meermaandenbundel?",
    monthsFooterBody: "Je betaalt in \u00e9\u00e9n keer voor {months} maanden, maar ontvangt elke maand opnieuw je volledige hoeveelheid data, minuten en sms\u2019jes. Is je bundel op? Je kunt altijd tussentijds extra herladen.",
  },
  en: {
    tagline: "Fast top-up for existing customers",
    yourDetails: "Your details",
    yourDetailsHint: "Enter your mobile number and email. Then pick a bundle.",
    mobileLabel: "Jan Mobile number",
    mobilePlaceholder: "+32 4XX XX XX XX",
    confirmMobileLabel: "Confirm number",
    confirmMobilePlaceholder: "Repeat your number",
    emailLabel: "Email address",
    emailPlaceholder: "name@example.com",
    emailHint: "You will receive a confirmation after payment.",
    tabAllIn: "All-In",
    tabData: "DATA Only",
    tabCredit: "Credit",
    tabAll: "All products",
    buy: "BUY",
    processing: "Please wait...",
    invalidMobile: "Enter a valid mobile number",
    mobileMismatch: "Mobile numbers do not match",
    invalidEmail: "Enter a valid email address",
    paymentCancelled: "Payment cancelled. You can try again.",
    contactTitle: "Customer service",
    whatsapp: "WhatsApp",
    email: "Email",
    footer: "Fast top-up for existing customers",
    paymentLoading: "Processing payment...",
    paymentLoadingHint: "One moment please, we are confirming your payment.",
    paymentSuccess: "Payment successful",
    paymentSuccessHint: "Thank you! Your bundle will be activated as soon as possible.",
    bundle: "Bundle",
    mobileNr: "Mobile nr.",
    amount: "Amount",
    status: "Status",
    paid: "Paid",
    confirmationSentTo: "A confirmation has been sent to",
    sessionExpired: "Session expired",
    timeout: "Timed out",
    somethingWrong: "Something went wrong",
    backToShop: "Back to shop",
    incl: "VAT incl.",
    popular: "POPULAR",
    freeWord: "free",
    dataPromo: "\ud83c\udf81 Temporarily FREE MIN & SMS with every DATA Only DEAL",
    bestDeal: "BEST DEAL",
    tabPrepaid: "1 Month Deal",
    tab3Month: "3 Month Deal",
    tab6Month: "6 Month Deal",
    perMonthShort: "/mo",
    months3Promo: "\ud83d\udcb0 Pay once, then each month for 3 months your deal is automatically topped up",
    months6Promo: "\ud83d\udcb0 Pay once, then each month for 6 months your deal is automatically topped up",
    months3Prefix: "3 Months",
    months6Prefix: "6 Months",
    creditPromo: "\u267e\ufe0f Unlimited validity",
    monthsFooterTitle: "How does a multi-month bundle work?",
    monthsFooterBody: "You pay once for {months} months, but each month you receive your full data, minutes and SMS again. Bundle used up? You can always top up in between.",
  },
  fr: {
    tagline: "Recharge rapide pour les clients existants",
    yourDetails: "Vos coordonn\u00e9es",
    yourDetailsHint: "Saisissez votre num\u00e9ro de mobile et votre e-mail. Choisissez ensuite un forfait.",
    mobileLabel: "Num\u00e9ro Jan Mobile",
    mobilePlaceholder: "+32 4XX XX XX XX",
    confirmMobileLabel: "Confirmez le num\u00e9ro",
    confirmMobilePlaceholder: "R\u00e9p\u00e9tez votre num\u00e9ro",
    emailLabel: "Adresse e-mail",
    emailPlaceholder: "nom@exemple.be",
    emailHint: "Vous recevrez une confirmation apr\u00e8s paiement.",
    tabAllIn: "All-In",
    tabData: "DATA uniquement",
    tabCredit: "Cr\u00e9dit",
    tabAll: "Tous les produits",
    buy: "ACHETER",
    processing: "Veuillez patienter...",
    invalidMobile: "Saisissez un num\u00e9ro de mobile valide",
    mobileMismatch: "Les num\u00e9ros de mobile ne correspondent pas",
    invalidEmail: "Saisissez une adresse e-mail valide",
    paymentCancelled: "Paiement annul\u00e9. Vous pouvez r\u00e9essayer.",
    contactTitle: "Service client",
    whatsapp: "WhatsApp",
    email: "E-mail",
    footer: "Recharge rapide pour les clients existants",
    paymentLoading: "Paiement en cours...",
    paymentLoadingHint: "Un instant s\u2019il vous pla\u00eet, nous confirmons votre paiement.",
    paymentSuccess: "Paiement r\u00e9ussi",
    paymentSuccessHint: "Merci\u00a0! Votre forfait sera activ\u00e9 d\u00e8s que possible.",
    bundle: "Forfait",
    mobileNr: "N\u00b0 mobile",
    amount: "Montant",
    status: "Statut",
    paid: "Pay\u00e9",
    confirmationSentTo: "Une confirmation a \u00e9t\u00e9 envoy\u00e9e \u00e0",
    sessionExpired: "Session expir\u00e9e",
    timeout: "D\u00e9lai d\u00e9pass\u00e9",
    somethingWrong: "Une erreur est survenue",
    backToShop: "Retour \u00e0 la boutique",
    incl: "TVA incl.",
    popular: "POPULAIRE",
    freeWord: "gratuit",
    dataPromo: "\ud83c\udf81 MIN & SMS gratuits temporairement avec chaque DEAL DATA Only",
    bestDeal: "MEILLEURE OFFRE",
    tabPrepaid: "Deal 1 Mois",
    tab3Month: "Deal 3 Mois",
    tab6Month: "Deal 6 Mois",
    perMonthShort: "/mois",
    months3Promo: "\ud83d\udcb0 Payez une fois, votre forfait est automatiquement recharg\u00e9 chaque mois pendant 3 mois",
    months6Promo: "\ud83d\udcb0 Payez une fois, votre forfait est automatiquement recharg\u00e9 chaque mois pendant 6 mois",
    months3Prefix: "3 Mois",
    months6Prefix: "6 Mois",
    creditPromo: "\u267e\ufe0f Validit\u00e9 illimit\u00e9e",
    monthsFooterTitle: "Comment fonctionne un forfait multi-mois\u00a0?",
    monthsFooterBody: "Vous payez une seule fois pour {months} mois, mais chaque mois vous recevez \u00e0 nouveau la totalit\u00e9 de vos donn\u00e9es, minutes et SMS. Forfait \u00e9puis\u00e9\u00a0? Vous pouvez toujours recharger entre-temps.",
  },
};

// Per-language product display name overrides (numbers/units stay the same)
export const PRODUCT_NAMES = {
  nl: {
    "credit-prefix": "Credit",
  },
  en: {
    "credit-prefix": "Credit",
  },
  fr: {
    "credit-prefix": "Cr\u00e9dit",
  },
};
